
<div class="performance-title">
  <span class="title">{{ tableHeader }}</span>>
  <loader class="loader" size="small" *ngIf="displayLoader"></loader>
  <h3 class="no-data-text" *ngIf="!displayLoader && (operationLocationData.length == 0 && fssLocationData.length == 0)">(No Data Found)</h3>
</div>
<div class="table-container" *ngIf="!displayLoader && (operationLocationData.length > 0 || fssLocationData.length > 0)">
  <table *ngIf="type == 'operations'">
    <tr>
      <th *ngFor="let col of columns">
        {{ col }}
      </th>
    </tr>
    <tr *ngFor="let data of this.operationLocationData">
      <td>{{ data.Location }}</td>
      <td>{{ data.GroupAverage }}%</td>
      <td>{{ data.AvgDetergent }}%</td>
      <td>{{ data.AvgRinseAdd }}%</td>
      <td>{{ data.AvgWashTank }}%</td>
    </tr>
  </table>
  <table *ngIf="type == 'fss'">
    <tr>
      <th *ngFor="let col of columns">
        {{ col }}
      </th>
    </tr>
    <tr *ngFor="let data of this.fssLocationData">
      <td>{{ data.Location }}</td>
      <td>{{ data.GroupAverage }}%</td>
      <td>{{ data.AvgWashTemp }}%</td>
      <td>{{ data.AvgRinseTemp }}%</td>
      <td>{{ data.AvgSanitizer }}%</td>
    </tr>
  </table>
</div>
